import React from "react"
import { journeys } from "../constants"
import { motion } from "framer-motion"
import { fadeIn } from "../utils/motion"
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component"

import "react-vertical-timeline-component/style.min.css"
import { useNavigate } from "react-router-dom"
const JourneyCard = ({ description, image, date }) => {
  return (
    <VerticalTimelineElement
      contentStyle={{
        background: "#1B1B1B",
        color: "#fff",
      }}
      contentArrowStyle={{ borderRight: "7px solid  #fff" }}
      date={date}
      iconStyle={{
        background: "#121212",
        display: "flex",
        justifyContent: "center",
      }}
      icon={
        <div className=" w-1/2 h-1/2 bg-white rounded-full mt-[10px] md:mt-[15px]   "></div>
      }
    >
      <div className="inline-block ">
        <div className="flex justify-center">
          <img src={image} alt="image" className=" object-contain"></img>
        </div>
        <div className="mt-5 ml-5 space-y-2 ">
          <span className="text-white-100 text-[14px] pl-1 tracking-wider">
            {description}
          </span>
        </div>
      </div>
    </VerticalTimelineElement>
  )
}

function Journeypage() {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate(-1)
  }
  return (
    <>
      {" "}
      <div className=" pt-20 px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] w-full ">
        {" "}
        <div className="pt-12 px-0 md:px-7">
          <div className="top-left-button " onClick={handleGoHome}>
            Go back
          </div>
          <motion.h2
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("left", "spring", 0.3, 0.4)}
            className="text-4xl lg:text-5xl leading-tight md:leading-normal font-semibold text-left"
          >
            <span className="tracking-wide font-leading ">
              Our journey so far:
            </span>
          </motion.h2>

          <motion.p
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("right", "tween", 0.5, 0.75)}
            className="mt-10 text-left text-zinc-400 text-[17px]"
          >
            {" "}
            A story of growth, resilience, and innovation. From humble
            beginnings, we embarked on a mission to disrupt the industry and
            make a meaningful impact. Through countless challenges and triumphs,
            we have transformed from a small startup into a leading player in
            our field. We have expanded our reach, forged valuable partnerships,
            and built a loyal customer base.
          </motion.p>
        </div>
      </div>
      <div className="mt-20 flex flex-col pb-20 black-gradient ">
        <VerticalTimeline>
          {journeys.map((journey, index) => (
            <JourneyCard key={` journey-${index}`} index={index} {...journey} />
          ))}
        </VerticalTimeline>
      </div>
    </>
  )
}

export default Journeypage
